import { render, staticRenderFns } from "./BaseId.vue?vue&type=template&id=7e4b52e6&scoped=true&"
import script from "./BaseId.vue?vue&type=script&lang=js&"
export * from "./BaseId.vue?vue&type=script&lang=js&"
import style0 from "./BaseId.vue?vue&type=style&index=0&id=7e4b52e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b52e6",
  null
  
)

export default component.exports